import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/bootstrap.scss";
import App from "./App";
import { AuthProvider } from "./hooks/context/AuthContext";
import { HelmetProvider } from "react-helmet-async";
import { analyticsInit } from "./utils/amplitude";

analyticsInit();

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

const helmetContext = {};

root.render(
    <HelmetProvider context={helmetContext}>
        <React.StrictMode>
            <AuthProvider>
                <App />
                {/* <div>w</div> */}
            </AuthProvider>
        </React.StrictMode>
    </HelmetProvider>,
);

// reportWebVitals();

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
